define('viewmodels/modals/dialogs/PlayOkayDialog',['knockout', 'underscore'], function (ko, _) {

    function turnIntoCssClass(param){
        return param.replace('_','-');
    }

    var PlayOkayDialog = function(dialog, block) {
        var self = this;
        self.dialog = dialog;
        self.title = block.title();
        self.intro = block.intro();
        self.items = block.items();
        self.cssClass = turnIntoCssClass(block.contentType());
        self.isContentTypeLink = self.cssClass === 'link-item';
    };

    PlayOkayDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return PlayOkayDialog;
});
